import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {RouterModule} from '@angular/router';
import {AuthGuardService} from '../../core/services';
import {AppConfigurationsPageComponent} from './pages/configurations-page/app-configurations-page.component';
import {ChipsModule} from 'primeng/chips';
import {KeyFilterModule} from 'primeng/keyfilter';
import {IncludeAppLinkConfigurationsComponent} from './components';
import {SharedModule} from '../shared/shared.module';

@NgModule({
  schemas: [NO_ERRORS_SCHEMA],
  imports: [
    RouterModule.forRoot([
      {
        path: 'app-configurations',
        component: AppConfigurationsPageComponent,
        canActivate: [AuthGuardService],
        data: {
          roles: ['GLOBAL_APP_CONFIG_VIEW_MENU'],
        },
        children: [
          {
            path: 'main',
            component: IncludeAppLinkConfigurationsComponent,
          },
        ],
      },
    ]),
    ChipsModule,
    KeyFilterModule,
    SharedModule,
  ],
  declarations: [
    AppConfigurationsPageComponent,
    IncludeAppLinkConfigurationsComponent
  ],
  exports: [],
})
export class AppConfigurationsModule {
}
